<template>
  <div>
    <hr style="border:none" />
    <div class="content-container p-0">
      <img src="@/assets/people/empty-record.png" style="width:450px" />
      <!-- <h2>Deliver Goods effectively!!</h2> -->
      <slot name="title"></slot>
      <slot name="content"></slot>
      <!-- <span style="color:gray">Create, customize and print professional Delivery Challans</span> -->
      <br />
      <hr style="border:none" />
      <router-link :to="{ name : RouteName}" v-if="RoutePermission(true,RouteName,'','','')">
        <b-button variant="primary" size="sm" class="mr-2">
          <slot name="page"></slot>
        </b-button>
        <slot name="importbutton"></slot>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: ["RouteName"]
};
</script>
<style scoped>
.content-container {
  background: #fff;
  -webkit-align-items: center;
  align-items: center;
  text-align: center;
  -webkit-justify-content: space-around;
  justify-content: space-around;
}
</style>
